"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Cache: true,
  ConfigManager: true,
  Config: true,
  Version: true,
  http: true,
  HTTPClient: true,
  Event: true,
  datePadding: true,
  DateLike: true,
  dateFormat: true,
  mergeFormStorage: true,
  mergeDevConfigFormStorage: true
};
Object.defineProperty(exports, "Cache", {
  enumerable: true,
  get: function get() {
    return _cache.Cache;
  }
});
Object.defineProperty(exports, "ConfigManager", {
  enumerable: true,
  get: function get() {
    return _config.ConfigManager;
  }
});
Object.defineProperty(exports, "Config", {
  enumerable: true,
  get: function get() {
    return _config.Config;
  }
});
Object.defineProperty(exports, "Version", {
  enumerable: true,
  get: function get() {
    return _version.Version;
  }
});
Object.defineProperty(exports, "http", {
  enumerable: true,
  get: function get() {
    return _http.http;
  }
});
Object.defineProperty(exports, "HTTPClient", {
  enumerable: true,
  get: function get() {
    return _http.HTTPClient;
  }
});
Object.defineProperty(exports, "Event", {
  enumerable: true,
  get: function get() {
    return _event.Event;
  }
});
Object.defineProperty(exports, "datePadding", {
  enumerable: true,
  get: function get() {
    return _date.datePadding;
  }
});
Object.defineProperty(exports, "DateLike", {
  enumerable: true,
  get: function get() {
    return _date.DateLike;
  }
});
Object.defineProperty(exports, "dateFormat", {
  enumerable: true,
  get: function get() {
    return _date.dateFormat;
  }
});
Object.defineProperty(exports, "mergeFormStorage", {
  enumerable: true,
  get: function get() {
    return _storage.mergeFormStorage;
  }
});
Object.defineProperty(exports, "mergeDevConfigFormStorage", {
  enumerable: true,
  get: function get() {
    return _storage.mergeDevConfigFormStorage;
  }
});

var _cache = require("./cache");

var _config = require("./config");

var _version = require("./version");

var _http = require("./http");

var _platform = require("./platform");

Object.keys(_platform).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _platform[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _platform[key];
    }
  });
});

var _event = require("./event");

var _date = require("./date");

var _storage = require("./storage");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@weike/toolkit/lib/index.js
// module id = 163
// module chunks = 3